/* tslint:disable:max-line-length */
import { DeepPartial, Messages } from '@empathybroker/ebx-gluon';

export const pt: DeepPartial<Messages> = {
  custom: {
    clearSearchInput: 'apagar',
    facetsHeader: 'Filtros'
  },
  close: { buttonText: '' },
  facets: {
    defaultRange: { fromHTML: 'mais de {min}' },
    titles: {
      price_facet: 'Preço',
      sizes_facet: 'Tamanho',
      color_facet: 'Cor'
    },
    toggle: {
      default: {
        openHTML: 'Filtrar {numFound} resultados',
        closeHTML: 'Mostrar {numFound} resultados'
      }
    }
  },
  history: {
    disable: 'on',
    enable: 'off'
  },
  search: {
    inputPlaceholderAlternativesHTML: ['']
  },
  noResults: {
    messageHTML: `<span class="ebx-no-results__mgoccessage-apologies">Não encontrámos resultados para </span>
         <span class="ebx-no-results__message-query">{query}'</span><span class="ebx-no-results__message-try-again">
        Estes são os produtos mais vistos</span>`
  },
  nextQueries: {
    titleHTML: 'Você pode estar interessado',
    nextQuery: {
      titleHTML: 'Outros utilizadores pesquisaram <span class="ebx-next-query__title-query">{query}</span>'
    }
  },
  partialResult: {
    messageHTML: `<span class="ebx-partials__message-apologies">Não pudemos encontrar resultados para </span><span class="ebx-partials__message-query">'{query}'</span><span class="ebx-partials__message-try-again"> Pode ser que lhe interessem os seguintes produtos</span>`,
    titleHTML: '<span class="ebx-partial-result__title-num-found">{numFound}</span> resultados para <span class="ebx-partial-result__title-term">{term}</span>'

  },
  sort: {
    titleHTML: 'Ordenar por {selectedItem}',
    sortTitles: {
      default: 'Relevância',
      priceAsc: 'Preço ascendente',
      priceDesc: 'Preço descendente',
      alphabeat: 'Alfabeticamente'
    }
  }
};
